import { Component, OnInit } from '@angular/core';
import { PageService } from 'src/app/services/page.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'app-history',
	templateUrl: './history.component.html',
	styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
	public content: SafeHtml = '';

	constructor(private page: PageService, private sanitizer: DomSanitizer) { }

	ngOnInit(): void {
		this.page.all().subscribe((data: any) => {
			if (data.code == 200) {
				data.data.forEach((page: any) => {
					if (page.name == 'Sobre Nós') {
						this.content = this.sanitizer.bypassSecurityTrustHtml(page.description);
					}
				});
			}
		});
	}
}
